import './StudentSpotlight.css';
import React from "react";

function StudentSpotlight() {

    return (
        <div className="studentSpotlight">
        </div>
    )
}

export default StudentSpotlight;